import TableContainerEvolved from "components/TableContainerEvolved";
import React, { useRef } from "react";
function LeanIXMappingsTable({ columns, fetchData, fetchFilters }) {
  const tableRef = useRef(null);
  return (
    <TableContainerEvolved
      api={fetchData}
      filtersApi={fetchFilters}
      columns={columns}
      tableRef={(ref) => (tableRef.current = ref)}
      showSizeChanger={true}
      disableURLUpdate
      enableScroll
    />
  );
}

export default LeanIXMappingsTable;
